"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tooltip = _interopRequireDefault(require("../../tooltip"));

var _constants = require("../constants");

var _folder = _interopRequireDefault(require("../../../assets/icons/folder.svg"));

var _folderDisabled = _interopRequireDefault(require("../../../assets/icons/folder-disabled.svg"));

var _hardDrive = _interopRequireDefault(require("../../../assets/icons/hard-drive.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LabelIcon = function LabelIcon(_ref) {
  var _iconClasses;

  var isLeaf = _ref.isLeaf,
      iconSource = _ref.iconSource,
      tooltip = _ref.tooltip,
      _ref$useDefaultIcon = _ref.useDefaultIcon,
      useDefaultIcon = _ref$useDefaultIcon === void 0 ? false : _ref$useDefaultIcon,
      _onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var iconClasses = (_iconClasses = {}, _defineProperty(_iconClasses, _constants.TreeNodeClasses.nodeIcon, true), _defineProperty(_iconClasses, _constants.TreeNodeClasses.nodeIconCursor, typeof _onClick === 'function'), _iconClasses);

  var getImageElement = function getImageElement(source) {
    return /*#__PURE__*/_react.default.createElement("img", {
      className: (0, _classnames.default)(_objectSpread({}, iconClasses)),
      src: source,
      onClick: function onClick() {
        if (typeof _onClick === 'function') _onClick();
      }
    });
  };

  if (!iconSource && !useDefaultIcon) {
    return null;
  }

  var icon = useDefaultIcon ? isLeaf ? _hardDrive.default : _folder.default : iconSource;
  icon = disabled ? isLeaf ? _hardDrive.default : _folderDisabled.default : icon;

  if (tooltip) {
    return /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": "tree-view-icon-tooltip-".concat(tooltip)
    }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: tooltip,
      position: "bottom"
    }, getImageElement(icon)));
  }

  return getImageElement(icon);
};

exports.LabelIcon = LabelIcon;